import { API, Storage } from 'aws-amplify';
import { Button } from 'primereact/button'
import React, { useState } from 'react'
import { GetByRestrictCustomerSpecificProductsCSVDownload } from '../../../../graphql/queries';
import { showToast } from '../../../ToastUtils';

function DownloadCsvTemplate({ t, DialogName }) {
    // loading for Templete button 
    const [loading, setLoading] = useState(false);
    // Download Csv Template for Product Visibility  
    const handleDownload = async () => {
        setLoading(true);
        let url;
        if (DialogName === "General") {
            url = await Storage.get(`CSV_Template/Product_Enable_Disable_Template.csv`);
        }
        else if (DialogName === "Customer-Specific") {
            url = await Storage.get(`CSV_Template/Restrict_Customer_Specific_Products_Template.csv`);
        }
        try {

            // Create a link element
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ProductVisiblity.csv');
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Clean up
            document.body.removeChild(link);
        }
        catch (error) {
            console.error('Error downloading file:', error);
        }
        finally {
            setLoading(false);
        }
    }

    const [MenuLoading, setMenuLoading] = useState(false)
    const getFullDateTime = () => {
        // Generating current date and time
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        const hours = currentDate.getHours();
        const minutes = currentDate.getMinutes();
        // const seconds = currentDate.getSeconds();
        const fullDateTime = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}_${hours < 10 ? '0' + hours : hours}H${minutes < 10 ? '0' + minutes : minutes}M`;
        return fullDateTime;
    }
    const downloadCSVFromBase64 = async () => {
        setMenuLoading(true);

        let base64String;

        try {

            const response = await API.graphql({
                query: GetByRestrictCustomerSpecificProductsCSVDownload
            });
            console.log(response);
            base64String = response.data.GetByRestrictCustomerSpecificProductsCSVDownload.base64;
            if (base64String.includes("data is empty")) {
                showToast("Data is empty. Please disable some products.", 3000);
            }
            else {
                const csv = atob(base64String);
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);

                const fullDateTime = getFullDateTime();

                link.setAttribute("download", `Restricted_Products}_${fullDateTime}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (e) {
            console.error("Failed to decode base64 string:", e);
        }
        finally {
            setMenuLoading(false);
        }
    }
    return (
        <div className={`flex flex-column gap-4 `}>


            <div className='border-2 border-dashed p-1 h-7rem  border-round-lg'>
                <div className='pl-2'>
                    Template Download
                </div>

                <div className='text-center p-3'>
                    <div className=''>
                        <Button className='w-8rem' icon="pi pi-download" label={t(`Template`)} loading={loading}
                            onClick={handleDownload}
                        />
                    </div>
                    <div className=''>
                        <span className='text-xs text-gray-500 '>
                            *{t(`Download the template to enter your product visibility details.`)}{" "}
                        </span>
                    </div>
                </div>
            </div>

            {DialogName === "Customer-Specific" && <div className='border-2 border-dashed p-1 h-7rem  border-round-lg'>

                <div className='pl-2'>
                    Current Disable Products List Download
                </div>
                <div className='text-center p-3'>
                    <div className=''>
                        <Button className='w-8rem' icon="pi pi-download" label={t(`Download`)} loading={MenuLoading}
                            onClick={downloadCSVFromBase64}
                        />
                    </div>
                    <div className=''>
                        <span className='text-xs text-gray-500 '>
                            *{t(`Download the CSV file of disable products list for Customers`)}
                        </span>
                    </div>
                </div>
            </div>}

        </div>
    )
}

export default DownloadCsvTemplate